import React from 'react';
interface HeaderProps {
  onNavigate?: (sectionId: string) => void;
}
export function Header({
  onNavigate
}: HeaderProps) {
  const handleApplyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('questionnaire');
    }
  };
  const handleSuccessStoriesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('success-stories');
    }
  };
  return <header className="bg-gradient-to-r from-slate-900 via-fuchsia-900 to-cyan-900 border-b border-fuchsia-500/20 sticky top-0 z-50 shadow-lg shadow-fuchsia-500/20" data-id="element-59">
      <div className="max-w-7xl mx-auto px-6 py-5" data-id="element-60">
        <div className="flex items-center justify-between" data-id="element-61">
          <div className="flex items-center gap-3" data-id="element-62">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qryXpCPdw9GNAUzYa5ptZw/PSI_Logo_w_Outer_Ring_-_Transparent_Background.png" alt="Peptide Science Institute Logo" className="w-10 h-10" data-id="element-63" />
            <div data-id="element-64">
              <h1 className="text-xl font-bold text-white leading-tight" data-id="element-65">
                Peptide Science Institute
              </h1>
              <p className="text-xs text-cyan-400 font-semibold" data-id="element-66">
                Transformation Services
              </p>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-6" data-id="element-67">
            <a href="#questionnaire" onClick={handleApplyClick} className="text-cyan-300 hover:text-cyan-400 transition-colors font-semibold text-sm cursor-pointer" data-id="element-68">
              Apply Now
            </a>
            <a href="#success-stories" onClick={handleSuccessStoriesClick} className="text-fuchsia-300 hover:text-fuchsia-400 transition-colors font-semibold text-sm cursor-pointer" data-id="element-69">
              Success Stories
            </a>
          </nav>
        </div>
      </div>
    </header>;
}